export default __webpack_public_path__ + "dafebf4db268621359de918c33897f7c.png";